import React, { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { getWebshopFooter } from '../../../containers/cms-container/services';
import styles from './KoszykLisieckiFooter.module.scss';

const przelewy24Icon = require("../../../assets/payments/przelewy24.svg").default;

const decodeHtml = (html: any) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
};

const getFooter = (languageCode: any) => getWebshopFooter(languageCode);

export default function KoszykLisieckiFooter() {
    const [footer, setFooter] = useState("");

    const getLanguageCode = () => localStorage.getItem("lang");

    useEffect(() => {
        const languageCode = getLanguageCode();

        if (languageCode) {
            getFooter(languageCode)
                .then((response: any) => {
                    const decodedHtml = decodeHtml(response.data);
                    setFooter(decodedHtml);
                })
                .catch((error: any) => {
                    console.error("Błąd pobierania footer:", error);
                });
        }
    }, []);

    return (
        <div className={styles.footer_container}>
            {footer && parse(DOMPurify.sanitize(footer))}
            <div className={styles.second_row}>
                <div className={styles.copyright}>
                    <div className={styles.left}>
                        <p>Powered by IT PLM 2024 © IsoTech Sp. z o.o.. All Rights Reserved</p>
                    </div>
                    <div className={styles.right}>
                        <img src={przelewy24Icon} alt="Przelewy24" />
                    </div>
                </div>
            </div>
        </div>
    );
};

